export var spiltReportParams = function (params) {
    var formattedParams = {
        module: {
            module_id: params.module_id,
            module_value: params.module_value,
            module_type: params.module_type,
            module_chinese_type: params.module_chinese_type,
            recommend_mode: params.recommend_mode,
            ner_mode: params.ner_mode,
        },
        element: {
            element_id: params.element_id,
            element_type: params.element_type,
            element_chinese_type: params.element_chinese_type,
            element_content: params.element_content,
        },
    };
    // 目前只有医院、疾病、活动卡片需要传这个参数
    if (!params.recommend_mode) {
        delete formattedParams.module.recommend_mode;
    }
    if (!params.ner_mode) {
        delete formattedParams.module.ner_mode;
    }
    return formattedParams;
};
export var formatReportModuleParams = function (params, reportModulePayload) {
    if (reportModulePayload === void 0) { reportModulePayload = {}; }
    var moduleParams = spiltReportParams(params).module;
    return {
        module: moduleParams,
        payload: reportModulePayload,
    };
};
